export var KonturColors = {
    red0Logo: '#fe4c4c',
    red10: '#ffebeb',
    red20: '#ffcbcb',
    red30: '#ffabab',
    red40: '#fe8c8c',
    redLightBasic50: '#fe6c6c',
    redBasic60: '#fe4c4c',
    red70: '#ed3f3f',
    red80: '#dd3333',
    red90: '#cc2626',
    red100: '#bb1919',
    red110: '#ab0d0d',
    redPromoAccent: '#6c1d45',
    orange0Logo: '#fc7630',
    orange10: '#ffe0c3',
    orange20: '#ffd1a0',
    orange30: '#ffc17d',
    orange40: '#ffb259',
    orangeLightBasic50: '#ffa236',
    orangeBasic60: '#ff8227',
    orange70: '#ea7324',
    orange80: '#d46421',
    orange90: '#bf561e',
    orange100: '#a9471b',
    orange110: '#943817',
    orangePromoAccent: '#661429',
    yellow0Logo: '#feca42',
    yellow10: '#ffeec2',
    yellow20: '#fde1a1',
    yellow30: '#fdd481',
    yellow40: '#fcc660',
    yellowLightBasic50: '#fcb73e',
    yellowBasic60: '#fda70c',
    yellow70: '#f69912',
    yellow80: '#ef8b17',
    yellow90: '#e77e1b',
    yellow100: '#de711e',
    yellow110: '#d46421',
    green0Logo: '#26ad50',
    green10: '#c7f9cc',
    green20: '#a7eeb3',
    green30: '#87e39a',
    green40: '#67d881',
    greenLightBasic50: '#46cd68',
    greenBasic60: '#26ad50',
    green70: '#23a14a',
    green80: '#209644',
    green90: '#1c8a3f',
    green100: '#197f39',
    green110: '#167333',
    greenGreen: '#144942',
    greenMint0Logo: '#00bea2',
    greenMint10: '#c6f5ec',
    greenMint20: '#a8eee2',
    greenMint30: '#8be7d8',
    greenMint40: '#6ddfcd',
    greenMintLightBasic50: '#4fd8c3',
    greenMintBasic60: '#00c5a8',
    greenMint70: '#00b59a',
    greenMint80: '#00a58d',
    greenMint90: '#00957f',
    greenMint100: '#008571',
    greenMint110: '#007564',
    greenMintPromoAccent: '#013f54',
    blue0Logo: '#2291ff',
    blue10: '#cdedff',
    blue20: '#aeddff',
    blue30: '#8fcdff',
    blue40: '#70bdff',
    blueLightBasic50: '#51adff',
    blueBasic60: '#2291ff',
    blue70: '#1f87ef',
    blue80: '#1c7edf',
    blue90: '#1874cf',
    blue100: '#156abe',
    blue110: '#1261ae',
    bluePromoAccent: '#153177',
    blueDark0Logo: '#366af3',
    blueDark10: '#dde6ff',
    blueDark20: '#becfff',
    blueDark30: '#9fb8ff',
    blueDark40: '#80a1ff',
    blueDarkLightBasic50: '#618aff',
    blueDarkBasic60: '#366af3',
    blueDark70: '#3365e8',
    blueDark80: '#3060dc',
    blueDark90: '#2e5ad1',
    blueDark100: '#2b55c5',
    blueDark110: '#2850ba',
    blueDarkPromoAccent: '#272567',
    purple0Logo: '#b750d1',
    purple10: '#f7d7ff',
    purple20: '#eabdf6',
    purple30: '#dea3ec',
    purple40: '#d189e3',
    purpleLightBasic50: '#c56fda',
    purpleBasic60: '#b750d1',
    purple70: '#aa49c3',
    purple80: '#9e43b5',
    purple90: '#913ca6',
    purple100: '#843698',
    purple110: '#782f8a',
    purplePromoAccent: '#452a78',
    mainLinkTextBlue90: '#1874cf',
    mainLinkShapeBlue60: '#2291ff',
    mainLinkBackgroundBlue10: '#cdedff',
    mainSuccessTextGreen90: '#1c8a3f',
    mainSuccessShapeGreen60: '#26ad50',
    mainSuccessBackgroundGreen10: '#c7f9cc',
    mainWarningTextYellow80: '#ef8b17',
    mainWarningShapeYellow50: '#fcb73e',
    mainWarningBackgroundYellow10: '#ffeec2',
    mainErrorTextRed90: '#cc2626',
    mainErrorShapeRed60: '#fe4c4c',
    mainErrorBackgroundRed10: '#ffebeb',
    grayscaleText: '#222222',
    grayscaleSecondaryText: '#757575',
    grayscaleDisabledText: '#adadad',
    grayscaleDarkBackground: '#d6d6d6',
    grayscaleBackground: '#e6e6e6',
    grayscaleLightBackground: '#f0f0f0',
    grayscale87Text: 'rgba(0, 0, 0, 0.87)',
    grayscale54SecondaryText: 'rgba(0, 0, 0, 0.54)',
    grayscale32DisabledText: 'rgba(0, 0, 0, 0.32)',
    grayscale16DarkBackground: 'rgba(0, 0, 0, 0.16)',
    grayscale10Background: 'rgba(0, 0, 0, 0.1)',
    grayscale6LightBackground: 'rgba(0, 0, 0, 0.06)',
    grayscale87TextWhite: 'rgba(255, 255, 255, 0.87)',
    grayscale54SecondaryWhite: 'rgba(255, 255, 255, 0.54)',
    grayscale32DisabledWhite: 'rgba(255, 255, 255, 0.32)',
    grayscale16White: 'rgba(255, 255, 255, 0.16)',
    grayscale10White: 'rgba(255, 255, 255, 0.1)',
    grayscale6White: 'rgba(255, 255, 255, 0.06)',
    grayscaleBlack000: '#000000',
    grayscaleWhiteFFF: '#ffffff',
    primaryDefault: '#3d3d3d',
    primaryHover: '#292929',
    primaryPressed: '#141414',
    linkStatesTextHoverBlue100: '#156abe',
    linkStatesTextPressedBlue110: '#1260ae',
    linkStatesShapeHoverBlue70: '#1f87ef',
    linkStatesShapePressedBlue80: '#1c7edf',
    successStatesTextHoverGreen100: '#197f39',
    successStatesTextPressedGreen110: '#167333',
    successStatesShapeHoverGreen70: '#23a14a',
    successStatesShapePressedGreen80: '#209644',
    warningStatesTextHoverYellow90: '#e77e1b',
    warningStatesTextPressedYellow100: '#de711e',
    warningStatesShapeHoverYellow60: '#fda70c',
    warningStatesShapePressedYellow70: '#f69912',
    errorStatesTextHoverRed100: '#bb1919',
    errorStatesTextPressedRed110: '#ab0d0d',
    errorStatesShapeHoverRed70: '#ed3f3f',
    errorStatesShapePressedRed80: '#dd3333',
    shade16Black: 'rgba(0, 0, 0, 0.16)',
    shade80White: 'rgba(255, 255, 255, 0.8)',
    elementsExceptionsHint: 'rgba(0, 0, 0, 0.76)',
    elementsExceptionsToastRed: 'rgba(210, 15, 0, 0.76)',
};
